import React from 'react';
import { oneOfType, arrayOf, node, string, bool, func } from 'prop-types';
import Icon from 'components/icon';

export default class Section extends React.Component {
    constructor(props) {
        super(props);

        this.state = { open: false };
    }

    toggleSection() {
        this.setState({ open: !this.state.open });
    }

    standardSection() {
        const additionalClassName = this.props.className || '';
        const { editable, isEditing, actionButtonHandler, cancelButtonHandler } = this.props;

        return (
            <div className={`content-section ${additionalClassName}`}>
                <div className={`content-section-title ${isEditing ? 'content-section-title-editing' : ''}`}>
                    {this.props.caption}
                    {editable && !isEditing &&
                        <button
                            className="content-section-editable-button"
                            onClick={actionButtonHandler}
                        >
                            <Icon glyph="pencil" />
                        </button>
                    }
                    {editable && isEditing &&
                        <React.Fragment>
                            <button
                                className="content-section-editable-button button-cancel-skin"
                                onClick={cancelButtonHandler}
                            >
                                <Icon glyph="cross" />
                            </button>
                            <button
                                className="content-section-editable-button"
                                onClick={actionButtonHandler}
                            >
                                <Icon glyph="tick" />
                            </button>
                        </React.Fragment>
                    }
                </div>
                <div className="content-section-content">
                    {this.props.children}
                </div>
            </div>
        );
    }

    openableSection() {
        const additionalClassName = this.props.className || '';
        const { editable, isEditing, actionButtonHandler, cancelButtonHandler } = this.props;

        return (
            <div className={`content-section togglable ${additionalClassName}`}>
                <div className={`content-section-title ${isEditing ? 'content-section-title-editing' : ''}`}>
                    {this.props.caption}
                    {editable && !isEditing &&
                        <button
                            className="content-section-editable-button"
                            onClick={actionButtonHandler}
                        >
                            <Icon glyph="pencil" />
                        </button>
                    }
                    {editable && isEditing &&
                        <React.Fragment>
                            <button
                                className="content-section-editable-button button-cancel-skin"
                                onClick={cancelButtonHandler}
                            >
                                <Icon glyph="cross" />
                            </button>
                            <button
                                className="content-section-editable-button"
                                onClick={actionButtonHandler}
                            >
                                <Icon glyph="tick" />
                            </button>
                        </React.Fragment>
                    }
                </div>
                {!isEditing &&
                    <React.Fragment>
                        <div className={`content-section-content${this.state.open ? ' closed' : ''}`}>
                            {this.props.closed}
                        </div>
                        <div className={`content-section-content${this.state.open ? '' : ' closed'}`}>
                            {this.props.opened}
                        </div>
                        <div
                            className="content-section-content-details"
                            role="button"
                            onClick={() => this.toggleSection()}
                            onKeyPress={() => this.toggleSection()}
                            tabIndex="0"
                        >
                            {this.state.open ? 'Hide' : 'Show'} details
                        </div>
                    </React.Fragment>
                }
                {isEditing &&
                    <React.Fragment>
                        <div className="content-section-content">
                            {this.props.opened}
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }

    render() {
        if (this.props.opened && this.props.closed) {
            return this.openableSection();
        }

        return this.standardSection();
    }
}

Section.propTypes = {
    children: oneOfType([arrayOf(node), node]),
    caption: string.isRequired,
    opened: node,
    closed: node,
    className: string,
    editable: bool,
    isEditing: bool,
    actionButtonHandler: func,
    cancelButtonHandler: func
};

Section.defaultProps = {
    children: null,
    opened: null,
    closed: null,
    className: '',
    editable: false,
    isEditing: false,
    actionButtonHandler: null,
    cancelButtonHandler: null
};
